<template>
    <div class="container pt-2">
       <PageTitle main="Clientes" sub="Cadastrar, alterar ou deletar Clientes" />
       testando
       <font-awesome-icon :icon="['fa', 'user-secret']"/>
    </div>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    
    name: "Home",
    data: function() {
        return {
            jwt: new VueEasyJwt()
            }
    },
    computed: {},
    components: { PageTitle },
    methods: {
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
    }
}
</script>

<style>
</style>